export default __webpack_public_path__ + "static/Axiforma-Bold-6f5cf078449c58a4bfaa768b111e195f.woff";